import useFileListQuery from '../api/useFileListQuery';

export default function useGetFiles(
  isGlobalFileManager,
  isCaseFileManager,
  isLeadFileManager,
  isClientFileManager,
  userContext,
  contextParams = {}
) {
  const { fileManagerFilters = {}, caseDetails, isFirmDocuments, currentView = 'list', query = '' } = contextParams;

  const result = useFileListQuery({
    isGlobalFileManager,
    isCaseFileManager,
    isLeadFileManager,
    isClientFileManager,
    isFirmDocuments,
    userContext,
    fileManagerFilters,
    caseDetails,
    currentView,
    query,
    pageLimit: undefined,
  });

  return {
    files: result.files,
    getFiles: result.getFiles,
    paginationToken: result.paginationToken,
    previousToken: result.previousToken,
    pageLimit: result.pageLimit,
    setPageLimit: result.setPageLimit,
    onNextPageClick: result.onNextPageClick,
    onPrevPageClick: result.onPrevPageClick,
    refetch: result.refetch,
    refetchWithFolder: result.refetchWithFolder,
  };
}
